export const MentorshipRoundStatus = Object.freeze({
  ACTIVE: "active",
  COMPLETED: "completed",
  UPCOMING: "upcoming",
});
